module.exports = __webpack_public_path__ + "img/email-content.dbfd8932.svg";